<div class="product-feature-multicoverage">
  <ng-container *ngIf="selectedCoverage.type === 'activable'; else fixed">
    <mfp-switch
      [name]="product.id + '-' + coverageGroup"
      [disabled]="disabled"
      [ngModel]="selectedCoverage.active"
      (ngModelChange)="onChangeActive($event)"
    ></mfp-switch>
  </ng-container>
  <ng-template #fixed>
    <div class="product-feature__icon">
      <ng-template>
        <img mfpLazyImage lazySrc="assets/icons/tick.svg" />
      </ng-template>
    </div>
  </ng-template>
  <div class="product-feature-multicoverage__content">
    <p class="product-feature-multicoverage__text">{{ description }}</p>
    <div class="product-feature-multicoverage__input">
      <div class="product-feature-multicoverage__select">
        <mfp-select
          view="agent"
          name="select"
          [disabled]="!selectedCoverage.active || disabled"
          [error]="selectedCoverage.active! && !disabled && getSelectError() != ''"
          [helper]="selectedCoverage.active! && !disabled ? getSelectError() : ''"
          [placeholder]="''"
          [required]="false"
          [readonly]="false"
          [success]="false"
          [options]="values"
          [ngModel]="getSelectValue()"
          (ngModelChange)="onChangeSelect($event)"
        ></mfp-select>
      </div>
      <mfp-input
        view="agent"
        name="input"
        [type]="'number'"
        [placeholder]="placeholder"
        [required]="false"
        [readonly]="false"
        [disabled]="!selectedCoverage.active || disabled"
        [success]="false"
        [error]="selectedCoverage.active! && !disabled && getAmountError() != ''"
        [helper]="selectedCoverage.active! && !disabled ? getAmountError() : ''"
        [ngModel]="getValue()"
        (ngModelChange)="onChangeAmount($event)"
      ></mfp-input>
    </div>
  </div>
</div>
